<script setup lang="ts">
import {computed} from "vue";
import {Cake, Clock, PackageOpen, ScanQrCode} from "@lucide/vue";
import {GiftStatistics} from "@/birthday-gift/interfaces";

const props = defineProps<{
    statistics: GiftStatistics | undefined;
}>();

const kpis = computed(() => [
    {
        icon: ScanQrCode,
        label: 'QR codes envoyés',
        value: String(props.statistics?.sent_count ?? 0),
        hint: 'sur 30 jours',
    },
    {
        icon: PackageOpen,
        label: 'Cadeaux remis',
        value: String(props.statistics?.redeemed_count ?? 0),
        hint: `${Math.round(props.statistics?.redeemed_rate ?? 0)} % des envois`,
    },
    {
        icon: Cake,
        label: 'Âge moyen',
        value: props.statistics?.average_age ? `${Math.round(props.statistics.average_age)} ans` : '—',
        hint: 'des patients concernés',
    },
    {
        icon: Clock,
        label: 'Délai moyen de retrait',
        value: props.statistics?.average_redeem_delay_days !== null
            && props.statistics?.average_redeem_delay_days !== undefined
            ? `${Math.round(props.statistics.average_redeem_delay_days)} j`
            : '—',
        hint: 'après l\'anniversaire',
    },
]);
</script>

<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
    <div
      v-for="kpi in kpis"
      :key="kpi.label"
      class="rounded-lg bg-white p-4 shadow"
    >
      <div class="mb-2 flex items-center gap-2 text-xs text-muted-foreground">
        <component
          :is="kpi.icon"
          class="h-4 w-4 text-primary"
        />{{ kpi.label }}
      </div>
      <div class="text-2xl font-bold leading-none text-primary">
        {{ kpi.value }}
      </div>
      <div class="mt-1.5 text-xs text-muted-foreground">
        {{ kpi.hint }}
      </div>
    </div>
  </div>
</template>
